import { Component, Input, ViewEncapsulation, Output, EventEmitter } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { ConfirmDialogComponent } from '../confirm-dialog/confirm-dialog.component';

@Component({

    selector: 'syn-notes',
    templateUrl: 'notes.component.html',
    styleUrls: ['notes.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class NotesComponent {
    @Input() content = '';
    @Input() editable = true;
    @Input() editLabel = 'Notes';
    @Input() emptyLabel = 'Aucune note n\'a été saisie';

    @Output() onUpdate = new EventEmitter<string>();

    public isEditing = false;
    public tmp: string;
    private dialogSubscriptions: Subscription;

    constructor(
        private matDialogue: MatDialog
    ) {}

    public startEditing(): void {
        this.tmp = this.content;
        this.isEditing = true;
    }

    public endEditing(): void {
        if (this.tmp === this.content) {
            this.isEditing = false;
            return;
        }
        const dialogRef = this.matDialogue.open(ConfirmDialogComponent, {
            data: {
                title: 'Souhaitez vous annuler les modifications ?',
                content: 'Êtes-vous certain de vouloir annuler les modifications ? Les modifications apportées seront perdues.'
            },
            width: '500px',
            autoFocus: false
        });
        this.dialogSubscriptions = dialogRef.afterClosed().subscribe(action => {
            if (action) {
                this.isEditing = false;
            }
            this.dialogSubscriptions.unsubscribe();
        });
    }

    public update(): void {
        this.onUpdate.emit(this.tmp);
        this.isEditing = false;
    }
}
